import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { cargarDatosInstanciaBPM, CodSubTipoFichaOFI, DscMensajeSpinner2, isEmpty, openModalMensaje, openModalMensajePrg } from 'src/app/general/variables';
import { RequestNewInstanceGC } from 'src/app/models/BPM/RequestNewInstanceGC';
import { DocumentoDet } from 'src/app/models/DocumentoDet';
import { EstadoRequest } from 'src/app/models/EstadoRequest';
import { Fur } from 'src/app/models/Fur';
import { General } from 'src/app/models/General';
import { AsignarInfoBPMService } from 'src/app/services/bpm/asignar-info.service';
import { ExternosService } from 'src/app/services/externos/externos.service';
import { FurService } from 'src/app/services/fur.service';
import { EvidenciasComponent } from '../denuncia/evidencias/evidencias.component';

@Component({
  selector: 'app-info-complementaria-web',
  templateUrl: './info-complementaria-web.component.html',
  styleUrls: ['./info-complementaria-web.component.css']
})
export class InfoComplementariaWebComponent implements OnInit {

  strDscMensajeSpinner: string = DscMensajeSpinner2;
  furRecup: Fur;

  @Output() guardadoInfoComplEmitter = new EventEmitter();
  @ViewChild(EvidenciasComponent) evidenciaC: EvidenciasComponent;

  flgInfoCompEnviado = false;
  strDscTitulo = 'Información complementaria';
  strDscInfoCompl = '';

  constructor(public dialog: MatDialog,
              protected asignarInfoBPMService: AsignarInfoBPMService,
              protected furService: FurService,
              protected externosService: ExternosService,
              private spinner: NgxSpinnerService, ) { }

  ngOnInit() {


  }

  validarGuardar() {


    if (isEmpty(this.strDscInfoCompl) ) {

      openModalMensaje('Información complementaria', 'Debe ingresar la Descripción de información complementaria', this.dialog);

      return false;

    }


    if (this.evidenciaC.listEvidencias.length == 0) {

      openModalMensaje('Información complementaria', 'Debe Adjuntar información, por favor verifique', this.dialog);

      return false;


    }

    return true;


  }

  setFurInfoCompl(fur: Fur) {

    this.furRecup = fur;

  }

  guardar() {

    let requestNewInstanceGC: RequestNewInstanceGC;
    const estadoRequest: EstadoRequest = new EstadoRequest();
    let newFur: Fur;
    let numCantInfoCompl = this.furRecup.nfurIdtipinfcompl;
    const numFurIdBase = this.furRecup.nfurId;
    const listDocumentoBase: DocumentoDet[] = this.furRecup.listaDocumentoAdjuntoDet;

    numCantInfoCompl = (numCantInfoCompl ? numCantInfoCompl : 0);

    numCantInfoCompl++;

    estadoRequest.tipo = 'IFURD3';
    estadoRequest.id = numFurIdBase;
    estadoRequest.estado = numCantInfoCompl;

    this.spinner.show();

    // this.strDscInfoCompl = this.strDscInfoCompl + " | ICOMP";



    // openModalMensajePrg(this.strDscTitulo,"¿Está seguro que desea enviar del registro de Información complementaria?",this.dialog).subscribe(result=>{

    //   //console.log("====result",result);

    //   if(result == false )
    //   {



    //   }

    // });

  }

  _errorTrx(err: string) {

    console.log('====error', err);
    this.spinner.hide();
    this._emitirGuardado(2);

  }


  _emitirGuardado(numCaso: number) {

    const dataReturn: General = new General();

    switch (numCaso) {
      case 1:

        dataReturn.flgCampo1 = true; // PROCESO EXITOSO



        break;

      case 2:

        dataReturn.flgCampo1 = false; // PROCESO CON ERROR



        break;

      default:
        break;
    }

    this.guardadoInfoComplEmitter.emit(dataReturn);


  }

  _postEnvio() {

    this.flgInfoCompEnviado = true;
    this.evidenciaC.evidenciaCReadEnable();

  }

  // _salir(){

  //   openModalMensajePrg(this.strDscTitulo,"¿Está seguro que desea salir del registro de Información complementaria?",this.dialog).subscribe(result=>{

  //     if(result == false )
  //     {

  //       this.salirOut.emit();

  //     }

  //   });

  // }

}
